/**
 * バリアント選択とメディアギャラリー連携スクリプト（画像ベース対応）
 */
document.addEventListener('DOMContentLoaded', function() {
  
  // セクションIDの取得
  const sectionId = document.querySelector('[data-section]')?.dataset.section;
  if (!sectionId) {
    console.error('セクションIDが見つかりません');
    return;
  }
  
  // バリアントデータの取得（強化版）
  const variantDataElement = document.getElementById(`variant-data-${sectionId}`) || 
                            document.querySelector('[type="application/json"][data-variant-data]') ||
                            document.querySelector('script[data-variant-data]');
  let variantData = [];
  
  if (variantDataElement) {
    try {
      variantData = JSON.parse(variantDataElement.textContent);
      // データ構造の確認
      if (variantData.length > 0) {
      }
    } catch (e) {
      console.error('バリアントデータ解析エラー:', e);
      return;
    }
  }
  
  // DOM要素の取得
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  const variantInputs = document.querySelectorAll('.variant-selector-radio');
  const mediaGallery = document.querySelector('media-gallery');
  const gallerySlider = document.querySelector(`#Slider-Gallery-${sectionId}`);
  const selectedValueElements = document.querySelectorAll('.selected-variant-value');
    
  /**
    * 選択されたオプションに一致するバリアントを見つける
    * - data-option-position(1/2/3) を元に option1/option2/option3 を構築して照合する
    * - 「カラー/サイズ」等の名称依存や Object.values の順序依存を排除
    **/

function findMatchingVariantByPosition() {
    const selected = { option1: null, option2: null, option3: null };

    document.querySelectorAll('.variant-selector-radio:checked').forEach((input) => {
      const pos = parseInt(input.dataset.optionPosition, 10); // "1" | "2" | "3"
      const val = input.dataset.optionValue;
      if (!pos || !val) return;
      if (pos === 1) selected.option1 = val;
      if (pos === 2) selected.option2 = val;
      if (pos === 3) selected.option3 = val;
    });

    // option1 が無いなら突合できない
    if (!selected.option1) return null;

    return (
      variantData.find((variant) => {
        if (!variant) return false;
        if (variant.option1 !== selected.option1) return false;
        if (selected.option2 && variant.option2 !== selected.option2) return false;
        if (selected.option3 && variant.option3 !== selected.option3) return false;
        return true;
      }) || null
    );
  }
  
  /**
   * 現在選択されているバリアントを更新（修正版）
   */
  function updateSelectedVariant() {
    
   // 一致するバリアントを検索（data-option-position ベース）
   const selectedVariant = findMatchingVariantByPosition();
    
    if (selectedVariant) {
      
      // 各種更新処理を実行
      updateCartForms(selectedVariant);
      updatePrice(selectedVariant);
      updateInventory(selectedVariant);
      updateMediaGallery(selectedVariant);
      updateUrl(selectedVariant);
      
      return selectedVariant;
    } else {
      // 必要ならデバッグ用に出す（本番では抑止推奨）
      // console.warn('該当バリアントなし（data-option-position照合）');
      return null;
    }
  }
  
  /**
   * カートフォーム更新
   */
  function updateCartForms(variant) {
    productForms.forEach(form => {
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }
    });
  }
  
  /**
   * 価格更新
   */
  function updatePrice(variant) {
    const priceElement = document.querySelector(`#price-${sectionId}`);
    if (priceElement && variant) {
      
      // 価格表示の更新
      try {
        const money = new Intl.NumberFormat('ja-JP', {
          style: 'currency',
          currency: 'JPY'
        }).format(variant.price / 100);
        
        const priceDisplay = priceElement.querySelector('.price-item--regular, .price__regular');
        if (priceDisplay) {
          priceDisplay.textContent = money;
        }
      } catch (error) {
        console.error('価格更新エラー:', error);
      }
    }
  }
  
  /**
   * 在庫更新
   */
  function updateInventory(variant) {
    const inventoryElement = document.querySelector(`#Inventory-${sectionId}`);
    if (inventoryElement && variant) {
      // 在庫表示の更新
      if (variant.available) {
        inventoryElement.style.display = 'block';
      } else {
        inventoryElement.style.display = 'none';
      }
    }
  }
  
  /**
   * メディアギャラリー更新（重要な修正）
   */
  function updateMediaGallery(variant) {
    if (!variant.featured_media) {
      return;
    }
    
    
    // 方法1: カスタムイベントでメディアギャラリーに通知
    const variantChangeEvent = new CustomEvent('variantChange', {
      detail: {
        variant: variant,
        mediaId: variant.featured_media.id
      }
    });
    document.dispatchEvent(variantChangeEvent);
    
    // 方法2: 直接スライダーを操作（バックアップ）
    if (gallerySlider) {
      const targetSlide = gallerySlider.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      
      if (targetSlide) {
        const slideIndex = Array.from(gallerySlider.children).indexOf(targetSlide.closest('.product__media-item'));
        
        if (slideIndex !== -1) {
          const slideWidth = targetSlide.closest('.product__media-item').offsetWidth + 16; // gap考慮
          
          gallerySlider.scrollTo({
            left: slideWidth * slideIndex,
            behavior: 'smooth'
          });
        }
      }
    }
    
    // 方法3: media-galleryのメソッド直接呼び出し
    if (mediaGallery && typeof mediaGallery.goToMediaId === 'function') {
      mediaGallery.goToMediaId(variant.featured_media.id);
    }
  }
  
  /**
   * URL更新
   */
  function updateUrl(variant) {
    const newUrl = `${window.location.pathname}?variant=${variant.id}`;
    window.history.replaceState({}, '', newUrl);
  }
  
  /**
   * テキスト表示更新
   */
  function updateVariantText(optionName, optionValue) {
    selectedValueElements.forEach(element => {
      if (element.dataset.option === optionName) {
        // スムーズなアニメーション
        element.classList.add('updating');
        
        setTimeout(() => {
          element.textContent = optionValue;
          element.classList.remove('updating');
        }, 150);
      }
    });
  }
  
  /**
   * バリアント選択イベントリスナー
   */
  variantInputs.forEach(input => {
    input.addEventListener('change', function() {
      if (!this.checked) return;
      
      // テキスト即座更新
      updateVariantText(this.dataset.optionName, this.dataset.optionValue);
      
      // バリアント更新（少し遅延でスムーズに）
      setTimeout(() => {
        updateSelectedVariant();
      }, 200);
    });
  });
  
  /**
   * フォーム送信前処理
   */
  productForms.forEach(form => {
    form.addEventListener('submit', function(event) {
      const hiddenInput = form.querySelector('input[name="id"]');
      
      if (!hiddenInput?.value) {
        event.preventDefault();
        console.error('バリアント未選択');
        alert('商品のバリエーションを選択してください');
        return false;
      }
    });
  });
  
  /**
   * デフォルトバリアントの設定
   */
  function setDefaultVariant(variant) {
    variantInputs.forEach(input => {
      const optionName = input.dataset.optionName;
      let shouldCheck = false;
      
      if (optionName === 'カラー' || optionName.toLowerCase().includes('color')) {
        shouldCheck = variant.option1 === input.dataset.optionValue;
      } else if (optionName === 'サイズ' || optionName.toLowerCase().includes('size')) {
        shouldCheck = variant.option2 === input.dataset.optionValue;
      } else {
        shouldCheck = variant.option3 === input.dataset.optionValue;
      }
      
      if (shouldCheck) {
        input.checked = true;
        updateVariantText(optionName, input.dataset.optionValue);
      }
    });
  }
  
  /**
   * 初期化
   */
  function initialize() {
    
    // 初期バリアント設定
    let initialVariant = updateSelectedVariant();
    
    if (!initialVariant && variantData.length > 0) {
      // デフォルトバリアント設定
      const defaultVariant = variantData.find(v => v.available) || variantData[0];
      
      if (defaultVariant) {
        // デフォルトバリアントに対応するラジオボタンを選択
        setDefaultVariant(defaultVariant);
        
        // カートフォーム設定
        productForms.forEach(form => {
          const hiddenInput = form.querySelector('input[name="id"]');
          if (hiddenInput) {
            hiddenInput.value = defaultVariant.id;
          }
        });
        
        // メディアギャラリーも初期化
        updateMediaGallery(defaultVariant);
      }
    }
    
  }
  
  // 初期化実行
  initialize();
  
  // 遅延初期化（DOM完全読み込み後）
  setTimeout(() => {
    if (variantInputs.length === 0) {
      initialize();
    }
  }, 1000);
});
